const radio = document.querySelector('.radio-modal');

if (null !== radio) {
	const radioToggle = document.querySelector('.header-top__radio');
	const radioClose = document.querySelector('.radio-modal__close');
	const mask = radio.querySelector('.mask');
	const closePopup = () => {
		radio.classList.remove('radio-modal--open');
	};

	radioToggle.onclick = () => {
		radio.classList.add('radio-modal--open');
	};

	radioClose.onclick = () => {
		closePopup();
	};

	mask.onclick = () => {
		closePopup();
	};

	document.addEventListener('keydown', (event) => {
		if (event.key !== 'Escape') {
			return;
		}
		closePopup();
	});
}
